export function niceStepSize(rough) {
	if (!Number.isFinite(rough) || rough <= 0) return 1;
	const exp = Math.floor(Math.log10(rough));
	const scale = 10 ** exp;
	const f = rough / scale;
	for (const m of [1, 2, 2.5, 5, 10]) {
		if (f <= m) return m * scale;
	}
	return 10 * scale;
}

/** Padded data range → axis min/max and tick list (high → low) with clean increments. */
export function niceYAxis(paddedMin, paddedMax, targetTickCount = 5) {
	const span = Math.max(paddedMax - paddedMin, 1e-9);
	let step = niceStepSize(span / Math.max(targetTickCount - 1, 1));
	let axisMin = Math.floor(paddedMin / step) * step;
	let axisMax = Math.ceil(paddedMax / step) * step;
	while (axisMin > paddedMin) axisMin -= step;
	while (axisMax < paddedMax) axisMax += step;

	let ticks = [];
	for (let t = axisMax; t >= axisMin - step * 1e-9; t -= step) {
		const rounded = step >= 1 ? Math.round(t) : Math.round(t * 10) / 10;
		ticks.push(rounded);
	}

	while (ticks.length > 8) {
		step = niceStepSize(step * 2);
		axisMin = Math.floor(paddedMin / step) * step;
		axisMax = Math.ceil(paddedMax / step) * step;
		while (axisMin > paddedMin) axisMin -= step;
		while (axisMax < paddedMax) axisMax += step;
		ticks = [];
		for (let t = axisMax; t >= axisMin - step * 1e-9; t -= step) {
			ticks.push(step >= 1 ? Math.round(t) : Math.round(t * 10) / 10);
		}
	}

	const range = Math.max(axisMax - axisMin, 1e-9);
	return { axisMin, axisMax, range, ticks };
}
